import React, { useState } from "react";
import { verifyOtp } from "../API/requests";
import Button from "../Components/Button";
import OtpInputs from "../Components/OtpInputs";

const Otp = ({
  setPageState,
  onResRecieve,
  mobileNumber,
  sessionId,
  setIsLoading,
}) => {
  const [otpPassword, setOtpPassword] = useState("");
  const checkDisabled = () => {
    if (!otpPassword) return true;

    if (otpPassword.length === 6) return false;
    return true;
  };

  const clickHandler = (e) => {
    setIsLoading(true);
    verifyOtp(otpPassword, sessionId, mobileNumber)
      .then((res) => {
        onResRecieve(res);
        setPageState("chargeCardForm");
      })
      .catch((error) => {
        onResRecieve(error.response.data);
      });
    e.preventDefault();
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (checkDisabled()) return;
    clickHandler();
  };

  return (
    <form className="otp-page" onSubmit={submitHandler}>
      <div className="page-desc">لطفا رمز پیامک شده را وارد کنید</div>
      <OtpInputs onOtpPartChange={setOtpPassword} />
      <Button
        disabled={checkDisabled()}
        onClick={clickHandler}
        text="تایید"
        variant="contained"
      />
    </form>
  );
};

export default Otp;
